@if(code) {
<div class="alert" [ngClass]="{'alert--warning': type === 'warning', 'alert--error': !type || type !== 'warning'}">
  <ion-icon class="icon" [ngClass]="{'icon-alert-triangle': type === 'warning', 'icon-circulo-error': !type || type !== 'warning'}"/>
  <div>
    <span class="alert--message">{{ 'error.' + code | translate }}</span>
  </div>
</div>
}
